<template>
  <!-- <span class="label label-info" style="padding:.1em .5em .2em;margin-left:3px;margin-right:3px;"></span> -->
  <v-chip small readonly color="primary" dark disabled class="special-text white--text">{{
    to
  }}</v-chip>
</template>

<script>
export default {
  props: ['to']
}
</script>

<style lang="scss">
.special-text .v-chip__content {
  // word-break: break-all;
  // white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/label.vue